import { FaStar } from "react-icons/fa";
import { FaUser } from "react-icons/fa6";
import { IoCalendarOutline } from "react-icons/io5";

export const shop = [
  {
    id: 1,
    icon: <FaStar />,
    name: "B",
    price: "$26.00",
    discountPrice: "$4.00",
    image: require("./images/Layer-52.jpg"),
  },
  {
    id: 2,
    icon: <FaStar />,
    name: "D",
    price: "$44.00",
    discountPrice: "$4.00",
    image: require("./images/Layer-53.jpg"),
  },
  {
    id: 3,
    icon: <FaStar />,
    name: "A",
    price: "$15.00",
    discountPrice: "$4.00",
    image: require("./images/Layer-54.jpg"),
  },
  {
    id: 4,
    icon: <FaStar />,
    name: "C",
    price: "$37.00",
    discountPrice: "$4.00",
    image: require("./images/Layer-52.jpg"),
  },
  {
    id: 5,
    icon: <FaStar />,
    name: "Ba",
    price: "$24.00",
    discountPrice: "$4.00",
    image: require("./images/Layer-53.jpg"),
  },
  {
    id: 6,
    icon: <FaStar />,
    name: "Da",
    price: "$14.00",
    discountPrice: "$4.00",
    image: require("./images/Layer-54.jpg"),
  },
  {
    id: 7,
    icon: <FaStar />,
    name: "Aa",
    price: "$18.00",
    discountPrice: "$4.00",
    image: require("./images/Layer-52.jpg"),
  },
  {
    id: 8,
    icon: <FaStar />,
    name: "Ca",
    price: "$30.00",
    discountPrice: "$4.00",
    image: require("./images/Layer-53.jpg"),
  },
  {
    id: 9,
    icon: <FaStar />,
    name: "B",
    price: "$20.00",
    discountPrice: "$4.00",
    image: require("./images/Layer-54.jpg"),
  },
  {
    id: 10,
    icon: <FaStar />,
    name: "Db",
    price: "$43.00",
    discountPrice: "$4.00",
    image: require("./images/Layer-52.jpg"),
  },
  {
    id: 11,
    icon: <FaStar />,
    name: "Ab",
    price: "$10.00",
    discountPrice: "$4.00",
    image: require("./images/Layer-53.jpg"),
  },
  {
    id: 12,
    icon: <FaStar />,
    name: "Cb",
    price: "$32.00",
    discountPrice: "$4.00",
    image: require("./images/Layer-54.jpg"),
  },
  // {
  //     id: 13,
  //     icon: <FaStar />,
  //     name: "Cba",
  //     price: "$32.00",
  //     discountPrice: "$4.00",
  //     image: require("./images/Layer-54.jpg")
  // }
];

export const testimonial = [
  {
    id: 1,
    icon: <FaStar />,
    name: "Lorem Ipsum",
    description:
      "Some quick example text to build on the card title and make up the bulk of the card's content.",
    image: require("./images/testimonial.jpg"),
  },
  {
    id: 2,
    icon: <FaStar />,
    name: "Lorem Ipsum",
    description:
      "Some quick example text to build on the card title and make up the bulk of the card's content.",
    image: require("./images/testimonial.jpg"),
  },
  {
    id: 3,
    icon: <FaStar />,
    name: "Lorem Ipsum",
    description:
      "Some quick example text to build on the card title and make up the bulk of the card's content.",
    image: require("./images/testimonial.jpg"),
  },
  {
    id: 4,
    icon: <FaStar />,
    name: "Lorem Ipsum",
    description:
      "Some quick example text to build on the card title and make up the bulk of the card's content.",
    image: require("./images/testimonial.jpg"),
  },
  {
    id: 5,
    icon: <FaStar />,
    name: "Lorem Ipsum",
    description:
      "Some quick example text to build on the card title and make up the bulk of the card's content.",
    image: require("./images/testimonial.jpg"),
  },
  {
    id: 6,
    icon: <FaStar />,
    name: "Lorem Ipsum",
    description:
      "Some quick example text to build on the card title and make up the bulk of the card's content.",
    image: require("./images/testimonial.jpg"),
  },
  {
    id: 7,
    icon: <FaStar />,
    name: "Lorem Ipsum",
    description:
      "Some quick example text to build on the card title and make up the bulk of the card's content.",
    image: require("./images/testimonial.jpg"),
  },
  {
    id: 8,
    icon: <FaStar />,
    name: "Lorem Ipsum",
    description:
      "Some quick example text to build on the card title and make up the bulk of the card's content.",
    image: require("./images/testimonial.jpg"),
  },
  {
    id: 9,
    icon: <FaStar />,
    name: "Lorem Ipsum",
    description:
      "Some quick example text to build on the card title and make up the bulk of the card's content.",
    image: require("./images/testimonial.jpg"),
  },
  {
    id: 10,
    icon: <FaStar />,
    name: "Lorem Ipsum",
    description:
      "Some quick example text to build on the card title and make up the bulk of the card's content.",
    image: require("./images/testimonial.jpg"),
  },
  {
    id: 11,
    icon: <FaStar />,
    name: "Lorem Ipsum",
    description:
      "Some quick example text to build on the card title and make up the bulk of the card's content.",
    image: require("./images/testimonial.jpg"),
  },
  {
    id: 12,
    icon: <FaStar />,
    name: "Lorem Ipsum",
    description:
      "Some quick example text to build on the card title and make up the bulk of the card's content.",
    image: require("./images/testimonial.jpg"),
  },
];

export const blogs = [
  {
    id: 1,
    dateIcon: <IoCalendarOutline />,
    adminIcon: <FaUser />,
    description: "Lorem ipsum, dolor sit amet consectetur elit.",
    image: require("./images/blogs-img.jpg"),
  },
  {
    id: 2,
    dateIcon: <IoCalendarOutline />,
    adminIcon: <FaUser />,
    description: "Lorem ipsum, dolor sit amet consectetur elit.",
    image: require("./images/blogs-img.jpg"),
  },
  {
    id: 3,
    dateIcon: <IoCalendarOutline />,
    adminIcon: <FaUser />,
    description: "Lorem ipsum, dolor sit amet consectetur elit.",
    image: require("./images/blogs-img.jpg"),
  },
  {
    id: 4,
    dateIcon: <IoCalendarOutline />,
    adminIcon: <FaUser />,
    description: "Lorem ipsum, dolor sit amet consectetur elit.",
    image: require("./images/blogs-img.jpg"),
  },
  {
    id: 5,
    dateIcon: <IoCalendarOutline />,
    adminIcon: <FaUser />,
    description: "Lorem ipsum, dolor sit amet consectetur elit.",
    image: require("./images/blogs-img.jpg"),
  },
  {
    id: 6,
    dateIcon: <IoCalendarOutline />,
    adminIcon: <FaUser />,
    description: "Lorem ipsum, dolor sit amet consectetur elit.",
    image: require("./images/blogs-img.jpg"),
  },
  {
    id: 7,
    dateIcon: <IoCalendarOutline />,
    adminIcon: <FaUser />,
    description: "Lorem ipsum, dolor sit amet consectetur elit.",
    image: require("./images/blogs-img.jpg"),
  },
  {
    id: 8,
    dateIcon: <IoCalendarOutline />,
    adminIcon: <FaUser />,
    description: "Lorem ipsum, dolor sit amet consectetur elit.",
    image: require("./images/blogs-img.jpg"),
  },
  {
    id: 9,
    dateIcon: <IoCalendarOutline />,
    adminIcon: <FaUser />,
    description: "Lorem ipsum, dolor sit amet consectetur elit.",
    image: require("./images/blogs-img.jpg"),
  },
  {
    id: 10,
    dateIcon: <IoCalendarOutline />,
    adminIcon: <FaUser />,
    description: "Lorem ipsum, dolor sit amet consectetur elit.",
    image: require("./images/blogs-img.jpg"),
  },
  {
    id: 11,
    dateIcon: <IoCalendarOutline />,
    adminIcon: <FaUser />,
    description: "Lorem ipsum, dolor sit amet consectetur elit.",
    image: require("./images/blogs-img.jpg"),
  },
  {
    id: 12,
    dateIcon: <IoCalendarOutline />,
    adminIcon: <FaUser />,
    description: "Lorem ipsum, dolor sit amet consectetur elit.",
    image: require("./images/blogs-img.jpg"),
  },
];

export const Quotedata = [
  {
    id: 1,
    page: "vista-view",
    name: "VistaView - Single Panel",
    image: require("./images/single_vv.png"),
  },
  {
    id: 2,
    page: "vista-view",
    name: "VistaView - Double Panel",
    image: require("./images/double_vv.png"),
  },
  {
    id: 3,
    page: "vista-view",
    name: "VistaView - Internal Corner",
    image: require("./images/internal_vv.png"),
  },
  {
    id: 4,
    page: "vista-view",
    name: "VistaView - External Corner",
    image: require("./images/external_vv.png"),
  },
  {
    id: 5,
    page: "smart-screen-motorized",
    name: "SmartScreen Motorized - Standard",
    image: require("./images/motorized.png"),
  },
  {
    id: 6,
    page: "smart-screen-motorized",
    name: "SmartScreen Motorized - Recessed Application",
    image: require("./images/recessed.png"),
  },
  {
    id: 3,
    page: "smart-screen",
    name: "SmartScreen",
    price: "$15.00",
    discountPrice: "$4.00",
    image: require("./images/Smart-Screen-Logo-B.png"),
  },
];